module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fullscreen-overlay-layout', {
    attrs: {
      "title": _vm.getCurrentRT.title
    },
    on: {
      "close": _vm.closeOverlay
    }
  }, [_c('div', {
    class: {
      'hidden-record': _vm.submission.is_hidden
    },
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('submission-card-header', {
    attrs: {
      "showHeaderOptions": false,
      "submission": _vm.submission
    }
  }), _vm._v(" "), _c('submission-response-text', {
    attrs: {
      "submission": _vm.submission,
      "shortenText": true,
      "smallFont": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "start-xs"
  }, [_c('span', {
    staticClass: "i",
    staticStyle: {
      "font-size": "12px",
      "color": "#273248"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.getPromptWordsLength) + " Words\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto mt3 tr pb4",
    attrs: {
      "id": "overlay-comment-list"
    }
  }, [_c('comment-card-list', {
    staticClass: "br3 shadow-1",
    attrs: {
      "submissionID": _vm.submissionID,
      "listOfComments": _vm.filteredCommentsToShow
    }
  }), _vm._v(" "), (_vm.commentsToShow.length > 1) ? _c('pl-button', {
    staticClass: "italics pl-primary-secondary pl-small",
    nativeOn: {
      "click": function($event) {
        return _vm.toggleShowComments.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.show_all_comments ? 'collapse comments' : 'see more comments') + "\n      ")]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0ddf447e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/individualCommentOverlay.vue
// module id = 1179
// module chunks = 61